/*
 * file-attachment (schema)
 */
import { boolean, integer, timestamp, uuid, varchar } from "drizzle-orm/pg-core"
import { schema } from "../constants"
import { patients } from "../patient/patient.schema"
import { users } from "../user/user.schema"
import { attachmentTypes } from "../attachment-type/attachment-type.schema"

export const fileAttachments = schema.table("file_attachments", {
	id: uuid("id").primaryKey().notNull().defaultRandom(),

	// --- Entity reference ---
	entityType: varchar("entity_type", { length: 64 }).notNull(), // e.g. 'consent_form', 'prescription'
	entityId: uuid("entity_id"),
	patientId: uuid("patient_id").references(() => patients.id, {
		onDelete: "set null",
	}),
	attachmentTypeId: uuid("attachment_type_id").references(() => attachmentTypes.id, {
		onDelete: "set null",
	}),

	// --- File metadata ---
	s3Key: varchar("s3_key", { length: 512 }).notNull(),
	fileName: varchar("file_name", { length: 256 }).notNull(),
	mimeType: varchar("mime_type", { length: 128 }).notNull(),
	fileSize: integer("file_size"),

	// --- System ---
	active: boolean("active").notNull().default(true),
	createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
	updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
	createdBy: uuid("created_by").references(() => users.id, { onDelete: "set null" }),
	updatedBy: uuid("updated_by").references(() => users.id, { onDelete: "set null" }),
})
